import React from 'react';
import type {BookingSummary, Housing, ShortReservation} from '@chekin/core';
import type {ActionableConditionKind} from './lockConditions';

export type RemoteAccessEnv = {
  isTokenValid: boolean;
  reservationId?: string;
  reservation?: ShortReservation;
  housing?: Housing;
  summary?: BookingSummary;
  guestStats: {
    totalGuests: number;
    totalRegisteredGuests: number;
    totalFullyRegisteredGuests: number;
  };
  isLockLink: boolean;
  navigation: {
    conditionPath: (kind: ActionableConditionKind) => string;
    home: string;
  };
};

export const RemoteAccessEnvContext = React.createContext<RemoteAccessEnv>({
  isTokenValid: false,
  guestStats: {totalGuests: 0, totalRegisteredGuests: 0, totalFullyRegisteredGuests: 0},
  isLockLink: false,
  navigation: {conditionPath: () => '/', home: '/'},
});

export function useRemoteAccessEnv() {
  return React.useContext(RemoteAccessEnvContext);
}
